import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import TableFilter from "./components/Multiple/TableFilter";
import VerificationGrid from "./components/Multiple/VerificationGrid";
import TableMultiple from "./components/Multiple/TableMultiple";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@material-ui/core/Tooltip";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import api from "../../api";
import { saveAs } from "file-saver";
import moment from "moment";
import { isDate } from "date-fns";
import {
  Role,
} from "../../enums/enums";
import utils from "../../utils/utils";
import { useSelector } from "react-redux";
import { Label } from "semantic-ui-react";

export default function AgreementMassiveCreate({ setIsLoading, setDataToast }) {
  const [totalRecords, setTotalRecords] = useState();
  const [dataTable, setDataTable] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [isSearching, setIsSearching] = useState(false);
  const [filterForm, setFilterForm] = useState({
    externalAgreementStatus: undefined,
    dateFrom: undefined,
    dateTo: undefined,
  });
  const itemsPerPage = 10;
  const [paginationData, setPaginationData] = useState({
    amount: 0,
    currentPage: 1,
  });
  const [viewTableMultipleAgreements, setViewTableMultipleAgreements] = useState(false);
  const [dataTableMultipleAgreements, setDataTableMultipleAgreements] = useState();
  const [multipleAgreements, setMultipleAgreements] = useState();
  const [multipleAgreementsDialog, setMultipleAgreementsDialog] = useState({
    open: false,
  });
  const [pathFileArchive, setPathFileArchive] = useState();
  const closeMultipleAgreementsDialog = () => {
    setMultipleAgreementsDialog({ open: false });
  };
  const changePage = (event, value) => {
    reloadData(value, itemsPerPage, false);
  };

  //List
  const [externalAgreementStatesList, setExternalAgreementStatesList] = useState();

  const { decoded } = useSelector((state) => state.authReducer);

  function alertMessage(text) {
    setDataToast({
      active: true,
      message: text,
      type: "error",
    });
  }

  function search() {
    reloadData(1, itemsPerPage, true);
  }

  function reloadData(page, pageSize, reloadPages) {
    setIsSearching(true);
    setIsLoading(true);
    let dateFrom;
    let dateTo;
    if (isDate(filterForm.dateFrom)) {
      dateFrom = filterForm.dateFrom.toISOString().slice(0, 10);
    }
    if (isDate(filterForm.dateTo)) {
      dateTo = filterForm.dateTo.toISOString().slice(0, 10);
    }

    api
      .getExternalAgreementByFilter(filterForm.externalAgreementStatus, dateFrom, dateTo, page, pageSize)
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let amount = paginationData.amount;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          amount = Math.ceil(data.cantidad / itemsPerPage);
        }

        setPaginationData({
          amount: amount,
          currentPage: currentPage,
        });
        let list = [];
        data.resultado.forEach((item) => {
          let name =
            (item.cliente.nombre ? item.cliente.nombre : "") +
            " " +
            (item.cliente.apellido ? item.cliente.apellido : "");
          list.push({
            id: item.id,
            customer: name,
            product: item.productName,
            categoryName: item.nombreProductoCategoria,
            agreementId: item.contratoId,
            documentNumber: item.cliente.numeroDocumento,
            status: item.status,
            documentNumber: item.cliente.numeroDocumento,
            processDate: item.fechaProcesado,
          });
        });

        setTotalRecords(data.cantidad);
        setDataTable(list);
        setIsSearching(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        alertMessage("Ocurrió un error al obtener los registros.");
      });
  }

  ///Región Carga de Archivo Masivo
  function loadMultipleAgreements(e) {
    let files = e.target.files;
    if (files) {
      setIsLoading(true);

      let data = new FormData();
      let file = files.item(0);
      if (file.type === "text/plain") {
        data.append("files", files.item(0));

        api
          .uploadFile(data)
          .then((res) => {
            let file = res.data.files[0].url;
            setMultipleAgreements(file);
            setMultipleAgreementsDialog({ open: true });
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
            alertMessage("Ocurrió un error al subir el archivo.");
          });
      }
    }
  }
  function getMultipleAgreements(e) {
    setIsLoading(true);
    let body = {
      pathFile: multipleAgreements,
    };
    setPathFileArchive(multipleAgreements);

    return new Promise((resolve, reject) => {
      api
        .getMultipleAgreements(body)
        .then((res) => {
          if (res.data) {
            setDataTableMultipleAgreements(res.data);
            setIsLoading(false);
            resolve(res.data); // Resuelve la promesa con res.data
          } else {
            setIsLoading(false);
            alertMessage("Ocurrió un error al leer el archivo.");
            reject("Ocurrió un error al leer el archivo."); // Rechaza la promesa
          }
        })
        .catch((e) => {
          setIsLoading(false);
          alertMessage("Ocurrió un error al subir el archivo. " + e.response.data.errores);
          reject("Ocurrió un error al subir el archivo."); // Rechaza la promesa
        });
    });
  }

  useEffect(() => {
    if (dataTableMultipleAgreements) {
      setViewTableMultipleAgreements(true);
    }
  }, [dataTableMultipleAgreements]);

  function postCreateMultipleAgreements(e) {
    setIsLoading(true);
    api
      .postCreateMultipleAgreements(pathFileArchive, e)
      .then((res) => {
        let count = res.data.length;
        setIsLoading(false);
        setViewTableMultipleAgreements(false);
        setMultipleAgreementsDialog({ open: false });
        utils.alertSuccess("Se han creado " + count + " contratos correctamente.");
      })
      .catch((e) => {
        setIsLoading(false);
        alertMessage("Ocurrió un error al procesar los contratos." + e.response.data.errores);
      });
  }
  ///Fin Región Carga de Archivo Masivo

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function ExportarExcel() {
    let status = filterForm.externalAgreementStatus;
    let dateFrom = isDate(filterForm.dateFrom) ? moment(filterForm.dateFrom).format("YYYY-MM-DD") : undefined;
    let dateTo = isDate(filterForm.dateTo) ? moment(filterForm.dateTo).format("YYYY-MM-DD") : undefined;

    setIsLoading(true);
    api
      .getMultipleAgreementsExcel(status, dateFrom, dateTo)
      .then((res) => {
        let extension = "xlsx";
        let tempFileName = "Contratos creación masiva";
        let fileName = `${tempFileName}.${extension}`;

        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        saveAs(blob, fileName);
        reloadData(1, itemsPerPage, true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }

  useEffect(() => {
    setIsLoading(true);
    let role = decoded.role;
    setIsAdmin(role === Role.AdminComercial ?? false);

    api.getStatusExternalAgreements().then((res) => {
      setExternalAgreementStatesList(utils.setDataInList(res.data));
    });
    setIsLoading(false);
  }, []);

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={11}>
                <h2>CREACIÓN MASIVA</h2>
              </Grid>
              <Grid item xs={1}>
                <input
                  className="c-none"
                  id="signature"
                  type="file"
                  accept="text/plain"
                  onChange={loadMultipleAgreements}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                />
                <Grid item md={12}>
                  {!isAdmin && (
                    <label htmlFor="signature">
                      <Tooltip title="Creación Masiva de Contratos" arrow>
                        <Button className="c-grid-btn c-btn-success" variant="contained" component="span" fullWidth>
                          <LibraryAddIcon />
                        </Button>
                      </Tooltip>
                    </label>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="c-grid-header-filter c-mt-10" item md={12}>
            {externalAgreementStatesList && (
              <TableFilter
                IsSearching={isSearching}
                FilterForm={filterForm}
                SetFilterForm={setFilterForm}
                SubmitFunction={search}
                ExternalAgreementStatesList={externalAgreementStatesList}
              />
            )}
          </Grid>
          {dataTable && dataTable.length > 0 && (
            <Paper className="c-mt-10 c-grid-results" elevation={3}>
              <Grid container>
                <Grid item xs={6}>
                  <Label
                    style={{
                      marginLeft: "5px",
                    }}
                    className="c-total-success"
                  >
                    Cantidad de registros en la búsqueda: {totalRecords}
                  </Label>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right", marginBottom: "5px" }}>
                  <Button className="c-btn-success" color="primary" onClick={ExportarExcel} variant="contained">
                    Exportar
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TableMultiple
                    setDataToast={setDataToast}
                    setIsLoading={setIsLoading}
                    data={dataTable}
                    reload={() => reloadData(1, 10, true)}
                  />
                </Grid>
                <Grid item xs={12} container direction="column" alignItems="center" justify="center">
                  <Pagination
                    className="c-pagination"
                    onChange={changePage}
                    page={paginationData.currentPage}
                    count={paginationData.amount > 1 ? paginationData.amount : 0}
                    shape="rounded"
                  />
                </Grid>
              </Grid>
            </Paper>
          )}
        </Grid>
      </Paper>

      <div>
        <Dialog open={multipleAgreementsDialog.open}>
          <DialogTitle id="form-dialog-title">Creación Masiva de Contratos</DialogTitle>
          <DialogContent>
            <Grid item md={12} xs={12}>
              <Alert severity="success">
                Archivo Subido{" "}
                <a href={multipleAgreements} target="_blank">
                  aqui.
                </a>
              </Alert>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={closeMultipleAgreementsDialog}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={getMultipleAgreements} className="c-btn-success">
              Previsualizar
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {viewTableMultipleAgreements && dataTableMultipleAgreements?.listaRegistros && (
        <Dialog onClose={() => setViewTableMultipleAgreements(false)} open maxWidth="95%">
          <VerificationGrid
            setIsLoading={setIsLoading}
            data={dataTableMultipleAgreements}
            onClose={() => setViewTableMultipleAgreements(false)}
            postCreateMultiple={() => postCreateMultipleAgreements(dataTableMultipleAgreements.listaRegistros)}
          />
        </Dialog>
      )}
    </>
  );
}
